import NestedRouteComponent from 'router/nestedViews/NestedRouteComponent';
import wrapLegacyRoute from 'router/legacy/wrapLegacyRoute';
import translation from 'translation';

const accountBrandsRoutes = [
  {
    path: 'brands',
    component: NestedRouteComponent,
    meta: {
      routeName: {
        segmentName: () => translation.tr('Brands')
      },
      permissions: ['READ_BRANDS']
    },
    children: [
      {
        path: '',
        name: 'brandsList',
        component: wrapLegacyRoute('brandsController', 'list')
      },
      {
        path: 'create',
        name: 'brandCreate',
        component: wrapLegacyRoute('brandsController', 'create')
      },
      {
        path: ':brandId(\\d+)',
        name: 'brandDetails',
        component: wrapLegacyRoute('brandsController', 'details')
      }
    ]
  }
];

export default accountBrandsRoutes;
